import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stringSorter } from "../../utils/functions.js";
import DataTable from "../../components/CustomDatatable/index.js";
import {
  Button,
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
  Form,
  Modal,
  message,
  Popconfirm,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  HomeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  getGlobalWhatsNew,
  addGlobalWhatsNew,
  updateGlobalWhatsNew,
  deleteGlobalWhatsNew
} from "../../store/actions/whatsNew.js";
import { Spinner } from "reactstrap";
import WhatsNewForm from "./WhatsNewForm.js";
import { enhanceColumnsWithFilters } from "../../components/ColumnFilters/index.js";
import CustomToggleSwitch from "../../components/CustomToggleSwitch.js";
import moment from "moment-timezone";

// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
const { Title } = Typography;

const WhatsNew = () => {
  document.title = "Global Whats New List";
  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const dispatch = useDispatch();
  const globalWhatsNew = useSelector((state) => state.whatsNew.list);
  console.log("globalWhatsNew :", globalWhatsNew);
  
  const [form] = Form.useForm();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteComfirmModalVisible, setDeleteComfirmModalVisible] =
    useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  useEffect(() => {
    const fetchGlobalWhatsNew = async () => {
      try {
        await dispatch(getGlobalWhatsNew());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchGlobalWhatsNew();
  }, [dispatch]);

  const handleCreate = async (values) => {
    try {
      console.log("selectedRecord:", selectedRecord);
      
      if (selectedRecord) {
        await dispatch(updateGlobalWhatsNew({ ...selectedRecord, ...values, form }));
      } else {
        await dispatch(addGlobalWhatsNew(values, form));
      }
      await dispatch(getGlobalWhatsNew());
    } catch (error) {
      console.error("Failed to save GlobalWhatsNew:", error);
    } finally {
      setSelectedRecord(null);
      setIsModalVisible(false);
    }
  };

  const handleChangeStatus = async (id, status) => {
    const formData = new FormData();

    formData.append("id", id);
    formData.append("status", status);
    console.log("id", id, status);
    await dispatch(getGlobalWhatsNew());
  };

  const confirmDelete = async (item) => {
    try {
      await dispatch(deleteGlobalWhatsNew(item.id));
      await dispatch(getGlobalWhatsNew());
    } catch (error) {
      message.error("An error occurred while deleting the item");
    }
  };

  useEffect(() => {
    const fetchAmazonOrders = async () => {
      try {
        await dispatch(getGlobalWhatsNew());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchAmazonOrders();
  }, [dispatch]);

  useEffect(() => {
    // console.log(globalWhatsNew);
  }, [globalWhatsNew]);

  const renderCell = (text) => (text ? text : "");
  const userRenderCell = (text) => (text ? text : "User");
  let columns = [
    {
      title: "feature",
      dataIndex: "feature",
      key: "feature",
      sorter: stringSorter("feature"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "link",
      dataIndex: "link",
      key: "link",
      sorter: stringSorter("link"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "View link",
      dataIndex: "link",
      key: "link",
      sorter: stringSorter("link"),
      sortDirections: ["ascend", "descend"],
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          View
        </a>
      ),
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      sorter: stringSorter("Date"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <CustomToggleSwitch
          record={record}
          onChangeStatus={handleChangeStatus}
        />
      ),
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setSelectedRecord(record);
              setIsModalVisible(true);
            }}
          >
            <EditOutlined />
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => confirmDelete(record)}
          >
            <Button type="link" danger><DeleteOutlined /></Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  columns = enhanceColumnsWithFilters(columns);

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Global Whats New</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                Manage Global Whats New
              </Title>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord(null);
                  setIsModalVisible(true);
                }}
              >
                Add Global WhatsNew
              </Button>
            </Col>
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={globalWhatsNew.map((item) => ({
                ...item,
                key: item.id,
                status: item.status ? 1 : 0,
              }))}
              columns={columns}
            />
          )}
        </Space>
      </Card>
      <WhatsNewForm
        visible={isModalVisible}
        onCreate={handleCreate}
        onCancel={() => setIsModalVisible(false)}
        record={selectedRecord}
        form={form}
      />
    </div>
  );
};

export default WhatsNew;
